import { environment } from '../../environments/environment';

const apiBase = environment.apiBase.endsWith('/')
  ? environment.apiBase.slice(0, -1)
  : environment.apiBase;

export const API_BASE = apiBase;
